<div class="page-container">
  <div class="page-header d-flex flex-wrap align-items-center justify-content-between gap-3 mb-3 mb-lg-4">
    <h1 class="mb-0">Location Settings</h1>
    <button type="button" class="btn btn-light d-flex align-items-center gap-2" (click)="goTo('/instant-rate-manager')">
      <i class="bi bi-arrow-left" aria-hidden="true"></i>
      Instant Rates Manager
    </button>
  </div>

  <div class="grid-container d-flex flex-column gap-4 w-100">
    <!-- Tabs / Navbar -->
    <nav class="w-100 overflow-x-auto">
      <ul class="nav nav-tabs border-0 gap-2 flex-nowrap" style="min-width: max-content">
        <li class="nav-item">
          <button class="nav-link d-flex align-items-center gap-2 px-4 py-3 text-nowrap" [class.active]="activeTab === 'locations'" (click)="setActiveTab('locations')">
            <i class="bi bi-geo-alt"></i>
            Manage Locations
          </button>
        </li>

        <li class="nav-item">
          <button class="nav-link d-flex align-items-center gap-2 px-4 py-3 text-nowrap" [class.active]="activeTab === 'depots'" (click)="setActiveTab('depots')">
            <i class="bi bi-building"></i>
            Manage Depots
          </button>
        </li>

        <li class="nav-item">
          <button class="nav-link d-flex align-items-center gap-2 px-4 py-3 text-nowrap" [class.active]="activeTab === 'configuration'" (click)="setActiveTab('configuration')">
            <i class="bi bi-gear"></i>
            Manage Configuration
          </button>
        </li>
      </ul>
    </nav>

    <div class="tab-content w-100">
      <div *ngIf="activeTab === 'locations'">
        <app-manage-locations></app-manage-locations>
      </div>
      <div *ngIf="activeTab === 'depots'">
        <app-manage-depots (noZonesFound)="setActiveTab('locations')"></app-manage-depots>
      </div>
      <div *ngIf="activeTab === 'configuration'">
        <app-manage-configurations></app-manage-configurations>
      </div>
    </div>
  </div>
</div>
